type Child = Node | string | null | undefined | false;

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  options: {
    className?: string;
    text?: string;
    attrs?: Record<string, string>;
    onClick?: (event: MouseEvent) => void;
  } = {},
  ...children: Child[]
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  if (options.className) node.className = options.className;
  if (options.text !== undefined) node.textContent = options.text;
  for (const [name, value] of Object.entries(options.attrs ?? {})) {
    node.setAttribute(name, value);
  }
  if (options.onClick) {
    node.addEventListener("click", (event) => options.onClick?.(event as MouseEvent));
  }
  for (const child of children) {
    if (typeof child === "string") node.append(document.createTextNode(child));
    else if (child) node.append(child);
  }
  return node;
}

export function button(
  label: string,
  onClick: () => void,
  variant: "primary" | "quiet" | "danger" = "primary",
) {
  return el("button", {
    className: `button button--${variant}`,
    text: label,
    attrs: { type: "button" },
    onClick,
  });
}

export function avatar(label: string) {
  return el("span", {
    className: "avatar",
    text: label.slice(0, 2).toLocaleUpperCase("tr"),
  });
}

export function statusLabel(status: string) {
  const labels: Record<string, string> = {
    confirmed: "Onaylandı",
    pending: "Bekliyor",
    cancelled: "İptal",
    resolved: "Tamamlandı",
    active: "Aktif",
    connected: "Bağlı",
    in_progress: "Canlı görüşme",
    ringing: "Çalıyor",
    ended: "Tamamlanıyor",
    not_connected: "Bağlı değil",
  };
  return el("span", {
    className: `status status--${status}`,
    text: labels[status] ?? status,
  });
}
